import { CustomConfirmDialog } from '@/components/CustomConfirmDialog'
import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { useInvokeBmw } from '@/hooks/useOffer'
import { Box, Button, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router'

export const UnauthorizedPageBmw = () =>{
  const [isGoingBack, setIsGoingBack] = useState(false)
  const { mutateAsync: invokeBmwAsync } = useInvokeBmw()
  const { insuranceParamsId } = useParams()
  const { lastApp: {app: lastApp} } = useApp()
  const navigate = useNavigate()

  if (lastApp != Apps.leasingSimplifiedWizard)
    navigate('/unauthorized')

  return <CustomConfirmDialog
    isOpen={true}
    onClose={() => {}}
    title="Nemáte oprávnění k obchodnímu případu"
    yesButton={{
      customElement: (
        <Button
          variant="solid"
          colorScheme="green"
          color='white'
          isLoading={isGoingBack}
          isDisabled={isGoingBack}
          onClick={() => {
            setIsGoingBack(true)
            invokeBmwAsync({ action: 'Cancel', paramsId: insuranceParamsId! })
              .catch(() => {
                alert('Při zpracování požadavku došlo k chybě')
              })
              .finally(() => {
                setIsGoingBack(false)
              })
          }}
          ml={3}
        >
          Rozumím
        </Button>
      )
    }}
    noButton={{
      customElement: <Box></Box>,
    }}>
    <Stack>
      <Text>Kliknutím na 'Rozumím' dojde k přesměrování zpět do původní aplikace.</Text>
    </Stack>
  </CustomConfirmDialog>
}